import axiosClient from './axiosClient';

const CHAT_PATH = '/chat';

class ChatApi {
  // Student login to get RC auth token
  studentLogin = async (registrationCode, phone) => {
    const url = `${CHAT_PATH}/student/login`;
    return axiosClient.post(url, { registrationCode, phone });
  };

  // Open DM with tech support (RC Token headers + body fallback)
  openDmTech = async ({ rcAuthToken, rcUserId, registrationCode, phone }) => {
    const url = `${CHAT_PATH}/student/dm/tech`;
    return axiosClient.post(
      url,
      { registrationCode, phone },
      {
        headers: {
          'x-rc-auth-token': rcAuthToken,
          'x-rc-user-id': rcUserId,
        },
      }
    );
  };

  // Open DM with teacher (RC Token headers + body fallback)
  openDmTeacher = async ({ rcAuthToken, rcUserId, registrationCode, phone }) => {
    const url = `${CHAT_PATH}/student/dm/teacher`;
    return axiosClient.post(
      url,
      { registrationCode, phone },
      {
        headers: {
          'x-rc-auth-token': rcAuthToken,
          'x-rc-user-id': rcUserId,
        },
      }
    );
  };

  // Get messages for a room. type='dm' for DM rooms, omit for channels.
  getMessages = async (roomId, rcAuthToken, rcUserId, count = 50, offset = 0, type) => {
    const url = `${CHAT_PATH}/messages/${roomId}`;
    const params = { count, offset };
    if (type) params.type = type;
    return axiosClient.get(url, {
      params,
      headers: {
        'x-rc-auth-token': rcAuthToken,
        'x-rc-user-id': rcUserId,
      },
    });
  };

  // Send a message to a room
  sendMessage = async (roomId, text, rcAuthToken, rcUserId) => {
    const url = `${CHAT_PATH}/messages/${roomId}`;
    return axiosClient.post(
      url,
      { text },
      {
        headers: {
          'x-rc-auth-token': rcAuthToken,
          'x-rc-user-id': rcUserId,
        },
      }
    );
  };

  // Delete own message
  deleteMessage = async (roomId, msgId, rcAuthToken, rcUserId) => {
    const url = `${CHAT_PATH}/messages/${roomId}/${msgId}`;
    return axiosClient.delete(url, {
      headers: {
        'x-rc-auth-token': rcAuthToken,
        'x-rc-user-id': rcUserId,
      },
    });
  };

  // Get unread counters for a room
  getUnreadCounters = async (roomId, rcAuthToken, rcUserId) => {
    const url = `${CHAT_PATH}/dm/counters/${roomId}`;
    return axiosClient.get(url, {
      headers: {
        'x-rc-auth-token': rcAuthToken,
        'x-rc-user-id': rcUserId,
      },
    });
  };

  // Đánh dấu toàn bộ tin nhắn trong room là đã đọc
  markRoomAsRead = async (roomId, rcAuthToken, rcUserId) => {
    const url = `${CHAT_PATH}/messages/${roomId}/read`;
    return axiosClient.post(
      url,
      {},
      {
        headers: {
          'x-rc-auth-token': rcAuthToken,
          'x-rc-user-id': rcUserId,
        },
      }
    );
  };
}

const chatApi = new ChatApi();
export default chatApi;
